<template>
	<div class="shopList">
		<div id="pointsMall" v-if="type == 'pointsMall'" :class="col == '1' ? 'odd_list list' : 'list'">
			<div class="col items" v-for="(item, index) in shopList" :key="item.id + 'index' + index + 'pointsMall'">
				<router-link :to="'/pointsMall/detail?id=' + item.id + '&pid='+item.sid">
					<p class="imgs">
						<img :src="item.thumb" />
						<span class="integral">第{{ item.qishu }}件</span>
					</p>
					<div>
						<p class="title">{{ item.title }}</p>
						<div class="option">
							<div class="user_lott" v-if="item.time == 0">
								<div class="user_head">
									<img
										src="http://xiaofu2023.oss-accelerate.aliyuncs.com/3a525202309111708247177.png" />
									<span class="van-ellipsis">{{ item.user.username || "" }}</span>
								</div>
								<p>换得编号：1111</p>
								<p>揭晓时间：1111</p>
								<div class="integral">10积分换得</div>
							</div>
							<div v-else>
								<p class="time_txt">倒计时</p>
								<van-count-down :time="item.time" millisecond format="mm:ss:SS">
									<template #default="timeData">
										<span class="block">{{ timeData.minutes }}</span>
										<span class="colon">:</span>
										<span class="block">{{ timeData.seconds }}</span>
										<span class="colon">:</span>
										<span class="block">{{
                      String(timeData.milliseconds)
                        .padStart(3, "0")
                        .substr(0, 2)
                    }}</span>
									</template>
								</van-count-down>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<!-- 积分商城购物车 -->
		<div id="pointsMall_cart" v-else-if="type == 'pointsMall_cart'" :class="col == '1' ? 'odd_list list' : 'list'">
			<div class="col items" v-for="item in shopList" :key="item.id + 'shop'">
				<router-link to="/detail?id=2">
					<p class="imgs">
						<img :src="item.productInfo.image" />
					</p>
					<div>
						<p class="title">{{ item.title }}</p>
					</div>
					<div class="progress">
						<van-progress stroke-width="4" :percentage="30" pivot-text=""
							color="linear-gradient(to right, #f8cb3e, #f7ce4d)" />
						<div class="text">
							<div class="item">
								<p>{{ item.canyurenshu }}</p>
								<p>已换取</p>
							</div>
							<div class="item">
								<p>{{ item.money }}</p>
								<p>总需积分</p>
							</div>
							<div class="item">
								<p>{{ item.shenyurenshu }}</p>
								<p>剩余</p>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div id="pointsMall_cart" v-else-if="type == 'pointsMall_cart_c'"
			:class="col == '1' ? 'odd_list list' : 'list'">
			<div class="col items" v-for="item in shopList" :key="item.id + 'shop'">
				<router-link :to="'/pointsMall/detail?id=' + item.id + '&pid='+item.sid">
					<p class="imgs">
						<img :src="item.image" style="height: 2.8rem" />
					</p>
					<div>
						<p class="title">{{ item.store_name || "" }}</p>
					</div>
					<div class="progress">
						<van-progress style="padding: 0px !important" stroke-width="7" :percentage="
                ((item.go_count || 0) / (item.all_count || 0)) * 100 >=
                100
                  ? 100
                  : ((item.go_count || 0) / (item.all_count || 0)) * 100
              " pivot-text="" color="linear-gradient(to right, #f8cb3e, #f7ce4d)" />
						<div class="text">
							<div class="item">
								<p>{{ item.go_count }}</p>
								<p>已换取</p>
							</div>
							<div class="item">
								<p>{{ item.all_count }}</p>
								<p>总需积分</p>
							</div>
							<div class="item">
								<p>{{ item.def_renshu }}</p>
								<p>剩余</p>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div v-else-if="type == 'custom'" :class="col == '1' ? 'odd_list list' : 'list'"
			:id="type == 'custom' ? 'custom' : ''">
			<div class="col items" v-for="(item, index) in shopList" :key="item.id + 'shop' + index + 'custom'">
				<router-link :to="'/detail?id=' + item.id + '&combinationId=1'">
					<p class="imgs">
						<img :src="item.image" />
						<span class="integral">赠送{{ item.give_integral || 0 }}积分</span>
					</p>
				</router-link>
				<div>
					<router-link :to="'/detail?id=' + item.id + '&combinationId=1'">
						<!-- <p class="title van-multi-ellipsis--l2">{{ item.store_name }}</p> -->
						<p class="title van-multi-ellipsis--l2">{{ item.store_name }}</p>
						<p class="tag">
							<span :style="{
                  color: tags.text_color,
                  background: tags.color ? tags.color : '#FD964E',
                }" v-for="(tags, indx) in item.tag" :key="tags.text + indx">{{ tags.text }}</span>
						</p>
					</router-link>
					<p class="integral" v-if="type == 'custom'">
						赠送{{ item.give_integral || 0 }}积分
					</p>
					<div class="option">
						<div>
							<p class="price"><i>¥</i>{{ item.price }}</p>
							<span :style="{ display: type == 'custom' ? 'none' : 'block' }" class="integral"
								v-if="col == '1'">赠送{{ item.give_integral || 0 }}积分</span>
						</div>
						<button :style="{ display: type == 'hideplay' ? 'none' : 'block' }" v-if="col == '1'"
							@click="$router.push({ path: '/detail?id=' + item.id + (item.is_benefit == 1 ? '&combinationId=1' : '') })">
							立即购买
						</button>
					</div>
				</div>
			</div>
		</div>
		<div v-else :class="col == '1' ? 'odd_list list' : 'list'" :id="type == 'custom' ? 'custom' : ''">
			<div class="col items" v-for="(item, index) in shopList" :key="item.id + 'shop' + index + 'custom'"
				>
				<router-link :to="`/detail?id=${item.id}${item.is_benefit == 1 ? '&combinationId=1' : ''}`">
					<p class="imgs">
						<img :src="item.image" />
						<span class="integral">赠送{{ item.give_integral || 0 }}积分</span>
					</p>
				</router-link>
				<div>
					<router-link :to="`/detail?id=${item.id}${item.is_benefit == 1 ? '&combinationId=1' : ''}`">
						<!-- <p class="title van-multi-ellipsis--l2">{{ item.store_name }}</p> -->
						<p class="title van-multi-ellipsis--l2">{{ item.store_name }}</p>
						<p class="tag">
							<span :style="{
                  color: tags.text_color,
                  background: tags.color ? tags.color : '#FD964E',
                }" v-for="(tags, indx) in item.tag" :key="tags.text + indx">{{ tags.text }}</span>
						</p>
					</router-link>
					<p class="integral" v-if="type == 'custom'">
						赠送{{ item.give_integral || 0 }}积分
					</p>
					<div class="option">
						<div>
							<p class="price"><i>¥</i>{{ item.price }}</p>
							<span :style="{ display: type == 'custom' ? 'none' : 'block' }" class="integral"
								v-if="col == '1'">赠送{{ item.give_integral || 0 }}积分</span>
						</div>
						<button :style="{ display: type == 'hideplay' ? 'none' : 'block' }" v-if="col == '1'"
							@click="detail(item)">
							立即购买
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "CommodityCom",
		props: {
			shopList: [],
			col: {
				type: String,
				default: "2",
			},
			type: {
				type: String,
				default: "",
			},
			cate_id:{
				type:Number,
				default:0
			},
			filter:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				isLoading: false,
				loading: false,
				finished: false,
			};
		},
		methods: {
			detail(data) {
				console.log(data);
				this.$router.push({
					path: "/detail?id=" + data.id
					// path: "/detail?id=" + data.id + '&customId=2&combinationId=' + (data.is_benefit == 1 ? 1 : 2)
				});
			},
		},
	};
</script>
<style scoped lang="scss">
	@import "./style.scss";
</style>
